import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NbCardModule } from "@nebular/theme";
import { AgGridModule } from "ag-grid-angular";
import { ArchivioAllertaMassimaRoutingModule } from "./archivio-allerta-massima-routing.module";
import { ArchivioAllertaMassimaComponent } from "./archivio-allerta-massima.component";
import { FormsModule } from "@angular/forms";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";



@NgModule({
  declarations: [ArchivioAllertaMassimaComponent],
  imports: [
    CommonModule,
    ArchivioAllertaMassimaRoutingModule,
    NbCardModule,
    AgGridModule,
    NgbDatepickerModule,
    FormsModule
  ],
  exports: [ArchivioAllertaMassimaComponent]
})
export class ArchivioAllertaMassimaModule { }
